import React from 'react';
export const GuaranteeSection = () => {
  return <section className="bg-familia-bg py-10 md:py-16 px-4 md:px-6" data-id="element-103">
      <div className="max-w-3xl mx-auto w-[92%] md:w-full" data-id="element-104">
        <div className="bg-familia-card border-2 border-familia-gold p-8 md:p-16 rounded-[2rem] md:rounded-[2.5rem] text-center relative overflow-hidden" data-id="element-105">
          <div className="text-5xl md:text-7xl mb-6 md:mb-10" data-id="element-106">🛡️</div>
          <h2 className="text-[22px] sm:text-2xl md:text-4xl font-display font-bold mb-6 md:mb-8 uppercase tracking-wider" data-id="element-107">
            THE VITALITY 360™ 30-DAY DIGNITY GUARANTEE
          </h2>
          <div className="space-y-1 md:space-y-2 mb-6 md:mb-10 text-lg sm:text-xl md:text-2xl font-bold" data-id="element-108">
            <p data-id="element-109">
              We are so confident that Vitality 360 will transform how your
              family provides care that we're taking all the risk off your
              shoulders.
            </p>
            <p data-id="element-110">Explore the entire system for 30 full days.</p>
            <p data-id="element-111">
              Use the workbooks. Try the exercises. Cook the recipes. Audit your
              home room by room.
            </p>
          </div>
          <div className="text-familia-gray text-[15px] md:text-xl leading-relaxed mb-6 md:mb-10 max-w-xl mx-auto" data-id="element-112">
            <p data-id="element-113">
              If you don't feel more organized, more confident and more at peace
              as a caregiver — contact us and we'll refund every penny.
            </p>
            <p className="text-white font-bold mt-3 md:mt-4" data-id="element-114">
              No questions. No hoops. No hassle.
            </p>
            <p className="mt-3 md:mt-4" data-id="element-115">
              Your family deserves the best care. And you deserve to feel
              confident providing it.
            </p>
          </div>
          <div className="inline-block bg-familia-green text-familia-bg font-bold px-5 md:px-6 py-2 rounded-full text-xs md:text-sm" data-id="element-116">
            30-Day Money-Back Guarantee
          </div>
        </div>
      </div>
    </section>;
};